import { IS_DEVELOPMENT_ANY } from '../../const/env';
import { ReactQueryConfigProviderV5, queryClientV5 } from './adapters/QueryClientProviderV5';
import { QueryClient } from './types/dataQueryClient';
import { FC, PropsWithChildren } from 'react';

// @ts-ignore
const dataQueryClient: QueryClient = queryClientV5;

if (IS_DEVELOPMENT_ANY) {
	window['__queryClient__'] = queryClientV5;
}

const DataQueryClientProvider: FC<PropsWithChildren> = ({ children }) => {
	return <ReactQueryConfigProviderV5>{children}</ReactQueryConfigProviderV5>;
};

function useDataQueryClient() {
	return dataQueryClient;
}

export { DataQueryClientProvider, useDataQueryClient, dataQueryClient };
